
import { Injectable } from '@angular/core';
let db: any;

@Injectable({
    providedIn: 'root'
})
export class IndexedStorageService {
  [x: string]: any;
  public storageName = '';

  getKey(keyname: any) {
      return new Promise(async (resolve, reject) => {
          const request = window.indexedDB.open('LokOS', 1);
          request.onsuccess = await function () {
              db = request.result;
              const trans = db.transaction(['LokOS']),
                  objectStore = trans.objectStore('LokOS');
              objectStore.openCursor(IDBKeyRange.lowerBound(keyname)).onsuccess =
          function (e: any) {
              if (db != undefined) {
                  if (e.target.result) {
                      resolve(e.target.result.value);
                  } else {
                      resolve(false);
                      reject(e);
                  }
              }
          };
          };
      });
  }

  addIndexStorage(keyName: any, value: any) {
      return new Promise(async (resolve, reject) => {
          let request = window.indexedDB.open('LokOS', 1);
          request.onsuccess = function (event: any) {
              db = request.result;
              request = db
                  .transaction(['LokOS'], 'readwrite')
                  .objectStore('LokOS')
                  .put(value, keyName);
              if (db != undefined) {
                  if (event.target.result) {
                      resolve('success');
                  } else {
                      reject(event);
                  }
              }
          };
      });
  }

  getIndexStorage<T = any>(keyName: string) {
      return new Promise<T>(async (resolve, reject) => {
          const openDBReq = window.indexedDB.open('LokOS', 1);
          openDBReq.onsuccess = () => {
              const transaction = openDBReq.result.transaction(['LokOS']);
              const objectStore = transaction.objectStore('LokOS');
              const getDataReq = objectStore.openCursor(
                  IDBKeyRange.lowerBound(keyName)
              );
              getDataReq.onsuccess = () => resolve(getDataReq.result?.value);
              getDataReq.onerror = reject;
          };
          openDBReq.onerror = reject;
      });
  }

  deleteIndexStorage() {
      return new Promise((resolve, reject) => {
          let request = window.indexedDB.open('LokOS', 1);
          request.onsuccess = function (event: any) {
              db = request.result;
              request = db
                  .transaction(['LokOS'], 'readwrite')
                  .objectStore('LokOS')
                  .delete('LokOS');
              if (db != undefined) {
                  if (event.target.result) {
                      window.indexedDB.deleteDatabase('LokOS');
                      resolve('success');
                  } else {
                      reject(event);
                  }
              }
          };
      });
  }
}
